import * as RadixTooltip from "@radix-ui/react-tooltip";

type Props = React.ComponentProps<typeof RadixTooltip.Provider> & {
    children: React.ReactNode;
};

const Provider = (props: Props) => {
    const { delayDuration = 150, ...otherProps } = props;

    return <RadixTooltip.Provider delayDuration={delayDuration} {...otherProps} />;
};

export { Provider };
export type { Props as ProviderProps };
